var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSameBidIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239.779,
    height: 152.718,
    viewBox: "0 0 239.779 152.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8389",
    "data-name": "Grupo 8389",
    transform: "translate(-11.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5744",
    "data-name": "Trazado 5744",
    d: "M238.575,520.807H0v-.635H238.685Z",
    transform: "translate(11.774 -368.59)",
    fill: "#3f3d56",
    stroke: "#ccc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5745",
    "data-name": "Trazado 5745",
    d: "M837.2,355.006l-6.335,12.541-18.942,8.611c-2.023,3.418-8.451,3.68-8.918,1.469-.524-2.48,7.806-6.472,7.806-6.472l15.843-10.716,1.386-9.225Z",
    transform: "translate(-618.603 -303.893)",
    fill: "#d5997f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5746",
    "data-name": "Trazado 5746",
    d: "M732.242,464.215l1.168,9.346-6.776.467-.7-9.814Z",
    transform: "translate(-514.39 -328.939)",
    fill: "#d5997f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5747",
    "data-name": "Trazado 5747",
    d: "M871.709,669.479a18.354,18.354,0,0,0,1.672-2.045c.971-1.344,1.833,5.55,1.833,5.55a12.509,12.509,0,0,1,.7,4.206c-.234,1.4-5.608,1.4-6.542,1.168a44.2,44.2,0,0,0-5.608,0h-7.01c-6.075-2.8,0-4.673,0-4.673,1.869-.234,8.178-6.075,8.178-6.075l1.4-2.57c.935-.234,1.869,3.271,1.869,3.271Z",
    transform: "translate(-654.792 -526.258)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5748",
    "data-name": "Trazado 5748",
    d: "M792.378,464.616l1.168,9.346-6.776.467-.7-9.814Z",
    transform: "translate(-557.002 -329.223)",
    fill: "#d5997f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5749",
    "data-name": "Trazado 5749",
    d: "M931.845,669.88a18.368,18.368,0,0,0,1.672-2.045c.971-1.344,1.833,5.55,1.833,5.55a10.838,10.838,0,0,1,.7,3.972c-.234,1.4-5.608,1.4-6.542,1.168a38.028,38.028,0,0,0-5.608.234h-7.01c-6.075-2.8,0-4.673,0-4.673,1.869-.234,8.178-6.075,8.178-6.075l1.4-2.57c.935-.234,1.869,3.271,1.869,3.271Z",
    transform: "translate(-697.404 -526.542)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5750",
    "data-name": "Trazado 5750",
    d: "M887.318,445.307c.935,1.168.467,5.14.467,5.14s1.635,12.851.935,14.02.467,2.1,1.168,3.739a37.324,37.324,0,0,1,1.4,5.608c3.972,3.271,3.739,18.225,3.739,18.225l1.4,13.318c-.467,1.4-7.01,1.636-7.944,1.4s-3.739-21.263-3.739-21.263l-6.309-11.917s.467,31.777.467,33.179-6.309.7-7.711.7-1.4-23.366-1.4-23.366l-1.4-6.075-7.477-27.805v-3.271l1.168-1.636S886.383,444.139,887.318,445.307Z",
    transform: "translate(-659.653 -370.198)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_910",
    "data-name": "Elipse 910",
    cx: 7.243,
    cy: 7.243,
    r: 7.243,
    transform: "translate(210.141 7.583)",
    fill: "#d5997f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5751",
    "data-name": "Trazado 5751",
    d: "M898.13,251.326c1.468,3.269.6,7.836-2.337,12.851l11.917-5.608-1.869-1.636.467-4.673Z",
    transform: "translate(-684.368 -233.113)",
    fill: "#d5997f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5752",
    "data-name": "Trazado 5752",
    d: "M873.7,272.44a7.477,7.477,0,0,0-3.03,4.367,41.391,41.391,0,0,0-1.778,9.887l-.566,10.046-7.01,26.637c6.075,5.14,9.58,3.972,17.758-.234s9.113,1.4,9.113,1.4.7-.234,0-.935,0,0,.7-.7,0,0-.234-.7,0-.234.234-.467-.935-2.337-.935-2.337l1.869-17.524,2.337-24.768c-2.8-3.5-10.748-6.542-10.748-6.542l-7.243,5.14c-2.337.935-.467-2.8-.467-2.8Z",
    transform: "translate(-659.937 -246.749)",
    fill: "#4eb0b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5753",
    "data-name": "Trazado 5753",
    d: "M942.522,343.937l.935,14.019L931.54,375.013c0,3.972-2.1,4.907-2.1,4.907a30.879,30.879,0,0,1-2.1-3.972,4.535,4.535,0,0,1,.7-4.673l8.178-17.291-3.5-8.645Z",
    transform: "translate(-706.445 -298.735)",
    fill: "#d5997f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5754",
    "data-name": "Trazado 5754",
    d: "M945.994,292.25c3.972,1.4,4.673,16.59,4.673,16.59-4.673-2.57-10.281,1.636-10.281,1.636s-1.168-3.972-2.57-9.113a8.93,8.93,0,0,1,1.869-8.412S942.022,290.848,945.994,292.25Z",
    transform: "translate(-713.89 -261.769)",
    fill: "#4eb0b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5755",
    "data-name": "Trazado 5755",
    d: "M904.967,217.438c-.922-.738-2.18.6-2.18.6l-.738-6.639a26.32,26.32,0,0,1-7.561-.184c-2.951-.738-3.412,2.674-3.412,2.674a23.679,23.679,0,0,1-.092-4.15c.184-1.66,2.582-3.32,6.824-4.426S904.262,209,904.262,209C907.213,210.48,905.889,218.176,904.967,217.438Z",
    transform: "translate(-680.924 -200.393)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5756",
    "data-name": "Trazado 5756",
    d: "M210.665,487.171c.8,3.161,7.587,10.271,14.594,16.947-10.805-26.689-4.648-55.9-4.648-55.9-2.006,11.472,25.491,69.2,25.491,69.2l-6.263,3.693-2.116,2.977C216.515,514.35,210.665,487.171,210.665,487.171Z",
    transform: "translate(-198.891 -372.629)",
    fill: "#66e4ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6078",
    "data-name": "Rect\\xE1ngulo 6078",
    width: 88.58,
    height: 17.489,
    transform: "translate(105.923 55.359)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6079",
    "data-name": "Rect\\xE1ngulo 6079",
    width: 88.58,
    height: 17.489,
    transform: "translate(105.923 27.725)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6080",
    "data-name": "Rect\\xE1ngulo 6080",
    width: 88.58,
    height: 17.489,
    transform: "translate(105.923)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5757",
    "data-name": "Trazado 5757",
    d: "M540.23,209.016h84.8V195.3h-84.8Z",
    transform: "translate(-432.418 -193.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5758",
    "data-name": "Trazado 5758",
    d: "M540.23,304.367h84.8V290.655h-84.8Z",
    transform: "translate(-432.418 -260.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5759",
    "data-name": "Trazado 5759",
    d: "M540.23,398.988h84.8V385.276h-84.8Z",
    transform: "translate(-432.418 -328.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_911",
    "data-name": "Elipse 911",
    cx: 5.224,
    cy: 5.224,
    r: 5.224,
    transform: "translate(110.012 3.407)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6081",
    "data-name": "Rect\\xE1ngulo 6081",
    width: 51.558,
    height: 1.136,
    transform: "translate(127.727 6.587)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6082",
    "data-name": "Rect\\xE1ngulo 6082",
    width: 51.558,
    height: 1.136,
    transform: "translate(127.727 9.539)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_912",
    "data-name": "Elipse 912",
    cx: 5.224,
    cy: 5.224,
    r: 5.224,
    transform: "translate(110.012 31.359)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6083",
    "data-name": "Rect\\xE1ngulo 6083",
    width: 51.558,
    height: 1.136,
    transform: "translate(127.727 34.539)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6084",
    "data-name": "Rect\\xE1ngulo 6084",
    width: 51.558,
    height: 1.136,
    transform: "translate(127.727 37.492)",
    fill: "#006384"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_913",
    "data-name": "Elipse 913",
    cx: 5.224,
    cy: 5.224,
    r: 5.224,
    transform: "translate(110.012 58.993)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6085",
    "data-name": "Rect\\xE1ngulo 6085",
    width: 51.558,
    height: 1.136,
    transform: "translate(127.727 62.173)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6086",
    "data-name": "Rect\\xE1ngulo 6086",
    width: 51.558,
    height: 1.136,
    transform: "translate(127.727 65.126)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5760",
    "data-name": "Trazado 5760",
    d: "M309.326,356.766s-1.221,7.677,3.839,6.979c0,0,20.065-4.536,21.112-3.49s7.555,1.4,7.216-3.01-6.867-1.875-6.867-1.875-10.12,1.4-12.213.349-8.026-.7-8.026-.7Z",
    transform: "translate(-268.71 -306.318)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5761",
    "data-name": "Trazado 5761",
    d: "M326.571,447.853l-2.782,26.4s-.872,10.469-3.49,12.737c0,0,0,3.315-.872,4.362l-1.221,13.784s1.745,5.06,1.57,5.932.7,3.664.523,4.013-8.375,0-8.375,0l1.745-28.091,5.409-39.083Z",
    transform: "translate(-270.643 -372.37)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5762",
    "data-name": "Trazado 5762",
    d: "M304.134,671.815s-3.659,9.227-1.75,10.341,21.955.318,21.955.318,3.341-2.068-.477-3.5a13.106,13.106,0,0,1-5.25-1.432,30.415,30.415,0,0,1-4.455-3.659s-.159-3.5-1.432-2.7a3.27,3.27,0,0,0-1.432,2.227Z",
    transform: "translate(-263.492 -530.533)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5763",
    "data-name": "Trazado 5763",
    d: "M284.231,667.344s-4.013,10.12-1.919,11.341,24.078.349,24.078.349,3.664-2.268-.523-3.839a14.374,14.374,0,0,1-5.758-1.57,33.355,33.355,0,0,1-4.885-4.013s-.174-3.839-1.57-2.966a3.585,3.585,0,0,0-1.57,2.443Z",
    transform: "translate(-249.231 -527.313)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5764",
    "data-name": "Trazado 5764",
    d: "M299.816,435.592s-1.919,17.971-2.792,21.81a49.622,49.622,0,0,0-1.047,7.677s-.174,5.583-1.745,7.154a4.716,4.716,0,0,0-1.4,3.49s-1.57,17.622-.7,19.716,2.057,4.814,1.184,6.21-10.781.421-10.781-.626,0-1.919-.523-2.443,0-3.839,0-3.839-2.094-15.529-.174-20.065,2.792-16.924,2.792-16.924-1.4-14.133-3.141-16.4.349-10.294.349-10.294Z",
    transform: "translate(-248.59 -360.467)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5765",
    "data-name": "Trazado 5765",
    d: "M329.2,242.907a2.345,2.345,0,0,0,1.13.963,33.8,33.8,0,0,1,6.819,5.48,8,8,0,0,1,.318-5.413,2.79,2.79,0,0,0,.4-1.822,2.268,2.268,0,0,0-.885-1.059,27.434,27.434,0,0,0-2.7-1.841c-.653-.391-2-1.431-2.746-1.318a6.965,6.965,0,0,1-.5,2.865C330.926,240.987,329.273,243.084,329.2,242.907Z",
    transform: "translate(-282.881 -223.59)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_914",
    "data-name": "Elipse 914",
    cx: 7.154,
    cy: 7.154,
    r: 7.154,
    transform: "translate(48.086 7.253)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5766",
    "data-name": "Trazado 5766",
    d: "M299.135,265.362s1.221-6.107-2.268-8.2-7.5-4.536-7.5-4.536-1.221-.174-1.745,2.443c0,0-9.945,1.919-10.992,11.341s.7,23.206.7,23.206-1.57,12.039-3.49,18.495c0,0-1.57,1.4,5.409-.7s19.193,5.932,19.193,5.932,1.221-1.221,1.221-2.094,2.617-27.393,3.141-29.836S300.705,265.711,299.135,265.362Z",
    transform: "translate(-243.546 -234.031)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5767",
    "data-name": "Trazado 5767",
    d: "M335.148,211.763a2.983,2.983,0,0,1,1.4-.374,2.67,2.67,0,0,0,1.388-.414c.676-.519.725-1.521,1.22-2.215.716-1,2.143-1.125,3.376-1.075a3.741,3.741,0,0,0,2.2-.332,3.3,3.3,0,0,0,1.167-1.95,2.643,2.643,0,0,0-.216-2.6c-.447-.452-1.153-.542-1.649-.939a72.688,72.688,0,0,0-7.158-1.854,6.972,6.972,0,0,0-8.132,4.413,21.588,21.588,0,0,0-1.362,4.538c.326,2.057,2.145,3.692,2.271,5.771a3.543,3.543,0,0,1,2.163-2.571.677.677,0,0,1,.441-.053c.181.058.286.238.4.39.3.4,1.238,1,1.77.718C334.9,212.96,334.549,212.169,335.148,211.763Z",
    transform: "translate(-281.594 -196.619)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5768",
    "data-name": "Trazado 5768",
    d: "M364.683,335.239a.8.8,0,0,0-.016,1.12l5.03,5.206a.794.794,0,0,0,1.131.011l15.35-15.283a.794.794,0,0,0-.127-1.228l-6.036-3.931a.789.789,0,0,0-.988.1Z",
    transform: "translate(-307.858 -282.485)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5769",
    "data-name": "Trazado 5769",
    d: "M386.184,335.737a.8.8,0,0,1-.105.13l-15.314,15.572a.794.794,0,0,1-1.131-.011L364.495,346a.791.791,0,0,1-.094-.118.713.713,0,0,0,.166.912L369.6,352a.794.794,0,0,0,1.131.011l15.35-15.283a.794.794,0,0,0,.105-1Z",
    transform: "translate(-307.758 -292.925)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5770",
    "data-name": "Trazado 5770",
    d: "M386.8,327.4l-.625-.4a.6.6,0,0,1-.857.781l-4.042-2.779a.595.595,0,0,1,.157-1.057l-.322-.205a.217.217,0,0,0-.27.03l-13.6,13.363a.217.217,0,0,0,.005.31l4.938,4.812a.216.216,0,0,0,.3,0l14.347-14.517a.217.217,0,0,0-.036-.336Z",
    transform: "translate(-309.8 -284.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5771",
    "data-name": "Trazado 5771",
    d: "M210.391,148.6l4.172,3.933,9.922-9.8-5.036-3.277Z",
    transform: "translate(-149.081 -98.814)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5772",
    "data-name": "Trazado 5772",
    d: "M427.591,345.118a.148.148,0,0,0,.2,0l.868-.868a.145.145,0,0,0,0-.2.148.148,0,0,0-.2,0l-.868.868a.145.145,0,0,0,0,.2Z",
    transform: "translate(-352.573 -298.784)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5773",
    "data-name": "Trazado 5773",
    d: "M422.575,350.13a.145.145,0,0,0,.2,0l.868-.868a.144.144,0,0,0-.2-.2l-.868.868A.144.144,0,0,0,422.575,350.13Z",
    transform: "translate(-349.019 -302.335)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_915",
    "data-name": "Elipse 915",
    cx: 0.974,
    cy: 0.974,
    r: 0.974,
    transform: "translate(60.432 52.186)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5774",
    "data-name": "Trazado 5774",
    d: "M291.851,347.446s-1.221,7.677,3.839,6.979c0,0,20.065-4.536,21.112-3.49s7.555,1.4,7.216-3.01-6.867-1.875-6.867-1.875-10.12,1.4-12.213.349-8.026-.7-8.026-.7Z",
    transform: "translate(-256.327 -299.714)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5775",
    "data-name": "Trazado 5775",
    d: "M297.622,269.4s-7.852.872-7.852,12.214v14.482l9.6-4.013s4.013-9.422,3.664-12.039S302.856,269.745,297.622,269.4Z",
    transform: "translate(-254.945 -245.916)",
    fill: "#e6e6e6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSameBidIcon);
export default __webpack_public_path__ + "static/media/user-same-bid-icon.3edd07c6268bf6032638fe483af096ff.svg";
export { ForwardRef as ReactComponent };